/**
 * IELTS Course Data Index
 */

import { fulfillLessonContract } from './fulfillLessonContract';
import { passiveVoiceData } from './grammar/passiveVoice';
import { sentenceStructureData } from './grammar/sentenceStructure';
import { subjectVerbAgreementData } from './grammar/subjectVerbAgreement';
import { gerundsData } from './grammar/gerunds';
import { infinitivesData } from './grammar/infinitives';
import { gerundsVsInfinitivesData } from './grammar/gerundsVsInfinitives';
import { sentenceClausesData } from './grammar/sentenceClauses';
import { modalVerbsData } from './grammar/modalVerbs';
import { relativeClausesData } from './grammar/relativeClauses';
import { nounClausesData } from './grammar/nounClauses';
import { adverbialClausesData } from './grammar/adverbialClauses';
import { complexSentencesData } from './grammar/complexSentences';
import { parallelStructureData } from './grammar/parallelStructure';
import { grammarRulesData } from './grammar/grammarRules';
import { presentSimpleData } from './grammar/presentSimple';
import { presentContinuousData } from './grammar/presentContinuous';
import { articlesBasicsData } from './grammar/articlesBasics';
import { basicPrepositionsData } from './grammar/basicPrepositions';
import { countableUncountableData } from './grammar/countableUncountable';
import { comparativesSuperlativesData } from './grammar/comparativesSuperlatives';
import { pastSimpleData } from './grammar/pastSimple';
import { pastContinuousData } from './grammar/pastContinuous';
import { presentPerfectIntroData } from './grammar/presentPerfectIntro';
import { futureFormsData } from './grammar/futureForms';
import { conjunctionsBasicData } from './grammar/conjunctionsBasic';
import { firstConditionalData } from './grammar/firstConditional';
import { zeroConditionalData } from './grammar/zeroConditional';
import { secondConditionalData } from './grammar/secondConditional';
import { reportedSpeechData } from './grammar/reportedSpeech';
import { presentPerfectAdvData } from './grammar/presentPerfectAdv';
import { questionTagsData } from './grammar/questionTags';
import { thirdConditionalData } from './grammar/thirdConditional';
import { mixedConditionalsData } from './grammar/mixedConditionals';
import { inversionData } from './grammar/inversion';
import { wishClausesData } from './grammar/wishClauses';
import { pastPerfectData } from './grammar/pastPerfect';
import { cleftSentencesData } from './grammar/cleftSentences';
import { ellipsisSubstitutionData } from './grammar/ellipsisSubstitution';
import { subjunctiveMoodData } from './grammar/subjunctiveMood';
import { advancedModalsData } from './grammar/advancedModals';
import { nominalizationData } from './grammar/nominalization';

import { essentialWordsData } from './vocabulary/essentialWords';
import { spellingUSUKData } from './vocabulary/spellingUSUK';
import { uncountableNounsData } from './vocabulary/uncountableNouns';
import { individualWordsData } from './vocabulary/individualWords';
import { collocationsData } from './vocabulary/collocations';
import { phrasalVerbsData } from './vocabulary/phrasalVerbs';
import { idiomsData } from './vocabulary/idioms';
import { topicVocabularyData } from './vocabulary/topicVocabulary';
import { paraphrasingData } from './vocabulary/paraphrasing';
import { vocabularyWritingData } from './vocabulary/vocabularyWriting';
import { commonVerbsData } from './vocabulary/commonVerbs';
import { dailyLifeVocabData } from './vocabulary/dailyLifeVocab';
import { numbersDatesTimeData } from './vocabulary/numbersDatesTime';
import { basicAdjectivesData } from './vocabulary/basicAdjectives';
import { familyPeopleData } from './vocabulary/familyPeople';
import { placesDirectionsData } from './vocabulary/placesDirections';
import { wordFamiliesData } from './vocabulary/wordFamilies';
import { linkingWordsBasicData } from './vocabulary/linkingWordsBasic';
import { foodHealthVocabData } from './vocabulary/foodHealthVocab';
import { travelTransportData } from './vocabulary/travelTransport';
import { educationVocabBasicData } from './vocabulary/educationVocabBasic';
import { prefixesSuffixesData } from './vocabulary/prefixesSuffixes';
import { awlSublist1Data } from './vocabulary/awlSublist1';
import { awlSublist2Data } from './vocabulary/awlSublist2';
import { awlSublist3Data } from './vocabulary/awlSublist3';
import { awlSublist4Data } from './vocabulary/awlSublist4';
import { awlSublist5Data } from './vocabulary/awlSublist5';
import { awlSublist6Data } from './vocabulary/awlSublist6';
import { awlSublist7Data } from './vocabulary/awlSublist7';
import { awlSublist8Data } from './vocabulary/awlSublist8';
import { awlSublist9Data } from './vocabulary/awlSublist9';
import { awlSublist10Data } from './vocabulary/awlSublist10';
import { awlSublist45Data } from './vocabulary/awlSublist45';
import { awlSublist67Data } from './vocabulary/awlSublist67';
import { awlSublist810Data } from './vocabulary/awlSublist810';
import { academicCollocationsData } from './vocabulary/academicCollocations';
import { sophisticatedConnectorsData } from './vocabulary/sophisticatedConnectors';
import { synonymsAntonymsData } from './vocabulary/synonymsAntonyms';
import { topicVocabEducationData } from './vocabulary/topicVocabEducation';
import { connectorsTransitionsData } from './vocabulary/connectorsTransitions';
import { topicVocabEnvironmentData } from './vocabulary/topicVocabEnvironment';
import { topicVocabTechnologyData } from './vocabulary/topicVocabTechnology';
import { topicVocabHealthData } from './vocabulary/topicVocabHealth';
import { formalRegisterData } from './vocabulary/formalRegister';
import { hedgingLanguageData } from './vocabulary/hedgingLanguage';
import { lessCommonVocabData } from './vocabulary/lessCommonVocab';
import { nuancedExpressionsData } from './vocabulary/nuancedExpressions';

import { listeningStrategiesData } from './skills/listening/listeningStrategies';
import { noteTakingData } from './skills/listening/noteTaking';
import { listeningDetailsData } from './skills/listening/listeningDetails';
import { accentTrainingData } from './skills/listening/accentTraining';
import { everydayConversationsData } from './skills/listening/everydayConversations';
import { followingDirectionsData } from './skills/listening/followingDirections';
import { understandingNumbersData } from './skills/listening/understandingNumbers';
import { paraphraseDetectionData } from './skills/listening/paraphraseDetection';
import { academicLecturesData } from './skills/listening/academicLectures';
import { distractorRecognitionData } from './skills/listening/distractorRecognition';
import { multipleSpeakersData } from './skills/listening/multipleSpeakers';
import { predictionSkillsData } from './skills/listening/predictionSkills';

import { skimmingScanningData } from './skills/reading/skimmingScanning';
import { readingStrategiesData } from './skills/reading/readingStrategies';
import { readingTimeManagementData } from './skills/reading/readingTimeManagement';
import { academicVocabularyData } from './skills/reading/academicVocabulary';
import { keywordIdentificationData } from './skills/reading/keywordIdentification';
import { tfngBasicsData } from './skills/reading/tfngBasics';
import { matchingHeadingsData } from './skills/reading/matchingHeadings';
import { identifyingWriterViewsData } from './skills/reading/identifyingWriterViews';
import { diagramLabellingData } from './skills/reading/diagramLabelling';
import { matchingInformationData } from './skills/reading/matchingInformation';
import { multipleChoiceAdvancedData } from './skills/reading/multipleChoiceAdvanced';
import { sentenceCompletionReadingData } from './skills/reading/sentenceCompletionReading';
import { speedReadingComplexData } from './skills/reading/speedReadingComplex';
import { summaryCompletionData } from './skills/reading/summaryCompletion';

import { task1OverviewData } from './skills/writing/task1Overview';
import { essayStructureData } from './skills/writing/essayStructure';
import { coherenceCohesionData } from './skills/writing/coherenceCohesion';
import { bandDescriptorsData } from './skills/writing/bandDescriptors';
import { basicParagraphStructureData } from './skills/writing/basicParagraphStructure';
import { simpleLinkingWordsData } from './skills/writing/simpleLinkingWords';
import { describingTrendsData } from './skills/writing/describingTrends';
import { opinionEssayFrameworkData } from './skills/writing/opinionEssayFramework';
import { discussionEssaysData } from './skills/writing/discussionEssays';
import { advancedCohesionData } from './skills/writing/advancedCohesion';
import { complexSentenceWritingData } from './skills/writing/complexSentenceWriting';
import { task1DataComparisonData } from './skills/writing/task1DataComparison';
import { task1GeneralLettersData } from './skills/writing/task1GeneralLetters';

import { fluencyTrainingData } from './skills/speaking/fluencyTraining';
import { pronunciationData } from './skills/speaking/pronunciation';
import { speakingPart2Data } from './skills/speaking/speakingPart2';
import { speakingPart3Data } from './skills/speaking/speakingPart3';
import { part1SimpleAnswersData } from './skills/speaking/part1SimpleAnswers';
import { selfIntroductionData } from './skills/speaking/selfIntroduction';
import { extendingAnswersData } from './skills/speaking/extendingAnswers';
import { hedgingSpeculatingData } from './skills/speaking/hedgingSpeculating';
import { advancedDiscourseData } from './skills/speaking/advancedDiscourse';
import { nuancedStanceData } from './skills/speaking/nuancedStance';
import { nativeLikeRepairData } from './skills/speaking/nativeLikeRepair';
import { abstractTopicsData } from './skills/speaking/abstractTopics';
import { basicPronunciationData } from './skills/speaking/basicPronunciation';
import { usingExamplesData } from './skills/speaking/usingExamples';

export {
  passiveVoiceData,
  sentenceStructureData,
  subjectVerbAgreementData,
  gerundsData,
  infinitivesData,
  gerundsVsInfinitivesData,
  sentenceClausesData,
  modalVerbsData,
  relativeClausesData,
  nounClausesData,
  adverbialClausesData,
  complexSentencesData,
  parallelStructureData,
  grammarRulesData,
  essentialWordsData,
  spellingUSUKData,
  uncountableNounsData,
  individualWordsData,
  collocationsData,
  phrasalVerbsData,
  idiomsData,
  topicVocabularyData,
  paraphrasingData,
  vocabularyWritingData,
  listeningStrategiesData,
  noteTakingData,
  listeningDetailsData,
  accentTrainingData,
  skimmingScanningData,
  readingStrategiesData,
  readingTimeManagementData,
  academicVocabularyData,
  task1OverviewData,
  essayStructureData,
  coherenceCohesionData,
  bandDescriptorsData,
  fluencyTrainingData,
  pronunciationData,
  speakingPart2Data,
  speakingPart3Data,
};

const allDataArray = [
  passiveVoiceData,
  sentenceStructureData,
  subjectVerbAgreementData,
  gerundsData,
  infinitivesData,
  gerundsVsInfinitivesData,
  sentenceClausesData,
  modalVerbsData,
  relativeClausesData,
  nounClausesData,
  adverbialClausesData,
  complexSentencesData,
  parallelStructureData,
  grammarRulesData,
  presentSimpleData,
  presentContinuousData,
  articlesBasicsData,
  basicPrepositionsData,
  countableUncountableData,
  comparativesSuperlativesData,
  pastSimpleData,
  pastContinuousData,
  presentPerfectIntroData,
  futureFormsData,
  conjunctionsBasicData,
  firstConditionalData,
  zeroConditionalData,
  secondConditionalData,
  reportedSpeechData,
  presentPerfectAdvData,
  questionTagsData,
  thirdConditionalData,
  mixedConditionalsData,
  inversionData,
  wishClausesData,
  pastPerfectData,
  cleftSentencesData,
  ellipsisSubstitutionData,
  subjunctiveMoodData,
  advancedModalsData,
  nominalizationData,
  essentialWordsData,
  spellingUSUKData,
  uncountableNounsData,
  individualWordsData,
  collocationsData,
  phrasalVerbsData,
  idiomsData,
  topicVocabularyData,
  paraphrasingData,
  vocabularyWritingData,
  commonVerbsData,
  dailyLifeVocabData,
  numbersDatesTimeData,
  basicAdjectivesData,
  familyPeopleData,
  placesDirectionsData,
  wordFamiliesData,
  linkingWordsBasicData,
  foodHealthVocabData,
  travelTransportData,
  educationVocabBasicData,
  prefixesSuffixesData,
  awlSublist1Data,
  awlSublist2Data,
  awlSublist3Data,
  awlSublist4Data,
  awlSublist5Data,
  awlSublist6Data,
  awlSublist7Data,
  awlSublist8Data,
  awlSublist9Data,
  awlSublist10Data,
  awlSublist45Data,
  awlSublist67Data,
  awlSublist810Data,
  academicCollocationsData,
  sophisticatedConnectorsData,
  synonymsAntonymsData,
  topicVocabEducationData,
  connectorsTransitionsData,
  topicVocabEnvironmentData,
  topicVocabTechnologyData,
  topicVocabHealthData,
  formalRegisterData,
  hedgingLanguageData,
  lessCommonVocabData,
  nuancedExpressionsData,
  listeningStrategiesData,
  noteTakingData,
  listeningDetailsData,
  accentTrainingData,
  everydayConversationsData,
  followingDirectionsData,
  understandingNumbersData,
  paraphraseDetectionData,
  academicLecturesData,
  distractorRecognitionData,
  multipleSpeakersData,
  predictionSkillsData,
  skimmingScanningData,
  readingStrategiesData,
  readingTimeManagementData,
  academicVocabularyData,
  keywordIdentificationData,
  tfngBasicsData,
  matchingHeadingsData,
  identifyingWriterViewsData,
  diagramLabellingData,
  matchingInformationData,
  multipleChoiceAdvancedData,
  sentenceCompletionReadingData,
  speedReadingComplexData,
  summaryCompletionData,
  task1OverviewData,
  essayStructureData,
  coherenceCohesionData,
  bandDescriptorsData,
  basicParagraphStructureData,
  simpleLinkingWordsData,
  describingTrendsData,
  opinionEssayFrameworkData,
  discussionEssaysData,
  advancedCohesionData,
  complexSentenceWritingData,
  task1DataComparisonData,
  task1GeneralLettersData,
  fluencyTrainingData,
  pronunciationData,
  speakingPart2Data,
  speakingPart3Data,
  part1SimpleAnswersData,
  selfIntroductionData,
  extendingAnswersData,
  hedgingSpeculatingData,
  advancedDiscourseData,
  nuancedStanceData,
  nativeLikeRepairData,
  abstractTopicsData,
  basicPronunciationData,
  usingExamplesData,
];

export const allCourseData = Object.fromEntries(
  allDataArray.filter(Boolean).map((d) => {
    const lesson = fulfillLessonContract(d);
    return [lesson.courseId, lesson];
  })
);
